<template lang="pug">
  v-circle(
    :color="color"
    :title.native="title | translate"
    @click.native="$emit('input', !value)")
</template>

<script>
import { COLORS } from '@/util/consts.js'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    color () {
      if (this.disabled) {
        return COLORS.GREY
      }
      return this.value
        ? COLORS.GREEN
        : COLORS.ORANGE
    },

    title () {
      if (this.disabled) {
        return 'base.disabled'
      } else if (this.value) {
        return 'base.selected'
      }
      return 'base.unselected'
    }
  }
}
</script>
